var map = {
	"./Mustard.png": 9979,
	"./Pizza.png": 9403,
	"./Rizo_1_kg.png": 1018,
	"./bbq.png": 2168,
	"./cheddar.png": 6738,
	"./chilli_mayo.png": 2517,
	"./fire.png": 3365,
	"./harrisa.png": 363,
	"./honey_mustard.png": 135,
	"./ketchup.png": 4451,
	"./lemon.png": 2380,
	"./mayo_classic.png": 7646,
	"./mustard_1_kg.png": 4618,
	"./pomegranate_molasses.png": 3886,
	"./ranch.png": 4819,
	"./sweet_chilli.png": 5593,
	"./texas.png": 4478,
	"./thai.png": 2387,
	"./thousand.png": 6491,
	"./toumaya.png": 9437
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5362;